const Hint = ({ }) => {
	return <div className="hint"></div>;
};

export default Hint;
